<div class="cet-grid-search-container">
  <div class="search-input">
    <label class="icon" style="min-width: 45px"
      ><img src="assets/images/search.svg" alt="search"
    /></label>
    <input
      type="text"
      name="search"
      id="search"
      class="cet-input"
      placeholder="Search {{ name }}"
      autocomplete="off"
      [(ngModel)]="searchTerm"
      (input)="startOnlineSearch()"
    />
  </div>
  <div class="view-options">
    <strong>{{ label }}</strong>
    <div>
      <img
        src="assets/images/list.svg"
        alt="list view"
        [class.active]="mode == 'list'"
        (click)="mode = 'list'"
      />
      <span class="mx-2"></span>
      <img
        src="assets/images/grid.svg"
        alt="grid view"
        [class.active]="mode == 'grid'"
        (click)="mode = 'grid'"
      />
    </div>
  </div>
  <div
    #Merchants
    class="grid-items-container cet-custom-scroll"
    [class.list]="mode == 'list'"
  >
    <ng-container *ngIf="loading">
      <p>loading....</p>
    </ng-container>
    <ng-container *ngIf="!loading && _data.length>0">
     
      <div
        class="item-container"
        *ngFor="let merchant of _data | filter : 'Merchant' : searchTerm"
      >
        <div
          class="item"
          [class.active]="currentValue == merchant"
          (click)="select(merchant)"
        >
          <div class="item-content">
            <img
              [src]="session.ImageUrl + 'StaticFiles/MerchantLogos/' + merchant[logo]"
              onerror="this.src='assets/images/NoimageFound.webp'"
              data-src-1="assets/images/NoimageFound.webp"
              data-src-2="assets/images/NoimageFound.webp"
              [alt]="merchant?.[text]"
              [title]="merchant?.[text]"
              style="width: 100px"
            />
            <p *ngIf="mode == 'list'" [title]="merchant?.[text]">
              {{ merchant?.[text]| truncate: [25, "..."]  }}
            </p>
          </div>
        </div>

        <p *ngIf="mode == 'grid'" [title]="merchant?.[text]">
          {{ merchant?.[text] | truncate: [25, "..."] }}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf=" _data.length==0">
      <div class="item-content" style="background-color: white; align-content: center; ">
        <img style="max-width: 80px;
        max-height: 80px;
        margin-block: 20px;"
          src="assets/images/NoimageFound.webp"
          [alt]=""
          [title]=""
          
        />
        <div>
          <span class="notfound" style="color: #BDBFC5  !important;" *ngIf="isLeft">No merchant found</span>
          <span class="notfound" style="color: #BDBFC5  !important;" *ngIf="!isLeft">لم يتم العثور على نتائج</span>
        </div>
        
      </div>
    </ng-container>
    
  </div>
  <div style="min-height: 35px">
    <img
      src="assets/images/rolling.webp"
      style="max-width: 25px"
      alt="loading"
      *ngIf="loadMoreLoading"
    />
  </div>
</div>
